/**
 * Textos (`es`) del vocabulario NEUTRO de los estados de un lote (OBR-14): lo que dicen igual el BackOffice, planta y la
 * consola. Namespace `domain.stockStates` (las claves las encuentran `stockStateReason`, `stockBlockReasonKey` y
 * `stockLotStateKey` de `domain/stockStates.ts`) y `backoffice.stockErrors`: los errores de las RPC de Existencias que la
 * pantalla no puede evitar con su propia validación. Tall propi: no se toca `es.ts`. Las tres lenguas han de tener las
 * mismas claves (i18n.test.ts).
 */

export const statesEs = {
  'domain.stockStates': {
    state_available: 'Disponible',
    state_blocked: 'Bloqueado',
    state_expired: 'Caducado',
    state_soon: 'Caduca pronto',
    stateBlockedLong: 'Bloqueado / Cuarentena',

    blockReason_expired: 'Caducado',
    blockReason_manual: 'Bloqueado a mano',
    blockReason_return: 'Devolución pendiente de salir',
    blockReason_exception: 'Excepción de recepción pendiente de decisión',

    reasonConsumeBlocked: 'Bloqueado: no se puede consumir ni expedir.',
    reasonConsumeExpired: 'Caducado: no se puede consumir ni expedir.',
    reasonMoveWarning:
      'Este lote no está disponible. Lo puedes mover, pero no se puede consumir ni expedir hasta que vuelva a estar disponible. Si es un bloqueo a mano, el lugar de destino también queda bloqueado: la cuarentena sigue a la mercancía.',
    reasonAdjustExpired: 'El lote ha caducado: el motivo recomendado es «Caducado».',
  },

  'backoffice.stockErrors': {
    badQuantity: 'La cantidad ha de ser distinta de cero.',
    badReason: 'Elige un motivo de la lista.',
    noteRequired: 'Hay que escribir el motivo del ajuste.',
    twoLots: 'Un movimiento pertenece a un solo lote: elige solo uno.',
    unknownArticle: 'Este artículo no existe en este obrador.',
    clientUuidConflict: 'Esta operación ya corresponde a otro movimiento. Vuelve a abrir el diálogo e inténtalo de nuevo.',
    untracked: 'Este artículo no tiene control de existencias.',
    unknownLot: 'Este lote no existe o no es de este artículo.',
    stateBadState: 'Este estado no se puede elegir: solo Disponible o Bloqueado.',
    stateLotRequired: 'Hay que elegir un lote (solo uno) para cambiarle el estado.',
  },
} as const;
